import { Component, OnInit } from '@angular/core';
import { Asset } from 'src/app/interfaces/asset';
import { ListService } from 'src/app/services/listService/list-service.service';

@Component({
  selector: 'app-my-list',
  templateUrl: './my-list.component.html',
  styleUrls: ['./my-list.component.less']
})
export class MyListComponent implements OnInit {
  assets: Asset[] = new Array();
  private isLoading = false;
  private offset = 0;
  private count = 20;
  constructor(private listService: ListService) { }

  ngOnInit(): void {
    this.assets = new Array();
    this.isLoading = false;
    this.offset = 0;
    this.getAssets();
  }

  // Get assets from server
  getAssets() {
    if (this.isLoading) {
      return;
    }
    let req = {
      offset: this.offset,
      count: this.count
    };
    this.isLoading = true;
    this.listService.getList(req).then((resp:any) => {
      this.assets = this.assets && this.assets.length ? this.assets.concat(resp.data.myList) : resp.data.myList;
      this.isLoading = !resp.data.nextPage;
      this.offset += this.count
    });
  }

  // On Scroll down
  onScroll() {
    this.getAssets();
  };

  // Delete selected items
  onDelete(data) {
    this.listService.removeList(data.map(obj => obj.id)).then((resp:any) => this.ngOnInit());
  }
}